// import shoppingConfig from "emun.shopping/shopping.config";
import orderConfig from "emun.order/order.config";
// import OrderDetailsPrompt from "emun.order/order-details-prompt";
import { getStates as getCatalogStates } from "emun.catalogs/catalog.states";
// import OrderDetailQuickView from "emun.order/quick-view/order-details-quick-view";
// import sleep from "webutils/services/sleep";
import { getInvStates } from "emun.invoice/inv/inv.states";

export default ({
  mode = "order",
  menu = "retailer",
  base = `${menu}.${mode}`,
  nav = 1,
  title = "Orders",
  icon = "usd",
  url = `/${mode}s`,
  breadcrumbs = false,
  pageHeader = false,
  retailerId,
  customerId = retailerId,
} = {}) => {
  const states = {
    [base]: {
      nav,
      menu, // <ui-view/>
      breadcrumbs,
      pageHeader,
      icon,
      title,
      url, // + "?uploaded&mode",
      params: {},
      rerouteTo: `${base}.list`,
      resolve: {
        retailerId: ($stateParams) =>
          $stateParams.retailerId || $stateParams.customerId || customerId,
        customerId: ($stateParams) =>
          $stateParams.customerId || $stateParams.retailerId || customerId,
      },
      templateProvider: ($stateParams) => `<order-container
        customer="$ctrl.customer"
        enable-query-string="true"
        detail-route="^.detail.lines"
        hide-header="true"
        customer-id="'${
          $stateParams.retailerId || $stateParams.customerId || customerId
        }'" />`,
    },
    [`${base}.list`]: {
      menu: base,
      nav: false,
      breadcrumbs: false,
      pageHeader: false,
      icon: "usd",
      title: "List",
      resolve: {},
      templateProvider: ($stateParams) => `<order-list  />`,
    },
    [`${base}.detail`]: {
      menu: base,
      nav: false,
      url: "/{orderId:[^/]+}?openedit",
      title: "Detail",
      breadcrumbs: false,
      pageHeader: false,
      rerouteTo: `${base}.detail.lines`,
      onExit($cart, $session) {
        console.debug("exiting cart", $cart);
        if ($session.isRetailer() && !$cart.canEdit) {
          if ($cart.$previousId) {
            $cart.load($cart.$previousId);
            delete $cart.$previousId;
          } else {
            $cart.reset();
          }
        }
      },
      resolve: {
        orderId: ($stateParams) => $stateParams.orderId,
        cart($cart, $stateParams) {
          if ($stateParams.orderId !== $cart.id) {
            $cart.$previousId = $cart.id;
            return $cart.load($stateParams.orderId).then((c) => {});
          }
        },
      },
      templateProvider: ($stateParams) => `<order-details 
            retailer-id="${$stateParams.retailerId}" 
            order-id="${$stateParams.orderId}" 
            openedit="${$stateParams.openedit}" 
            mode="${mode}"/>`,
    },
  };

  (orderConfig.routes || []).forEach(({ name, ...sr }, index) => {
    //console.info("base", base, name);
    if (name === "invoices") {
      Object.assign(
        states,
        getInvStates({
          menu: `${base}.detail`,
          nav: index + 2,
          ...sr,
        })
      );
      return;
    }
    states[base + ".detail." + name] = {
      nav: false, // index + 2,
      menu: `${base}.detail`,
      breadcrumbs: false,
      pageHeader: false,
      url: `/${name}`,
      resolve: {
        orderId: ($stateParams) => $stateParams.orderId,
      },
      templateProvider: ($stateParams) =>
        `<order-details-${name} order-id="${$stateParams.orderId}" mode="${mode}"/>`,
      ...sr,
    };
    (sr.routes || []).forEach((ssr, ssri) => {
      states[base + ".detail." + name + "." + ssr.name] = {
        nav: ssri + 2,
        menu: base + ".detail." + name,
        url: `/${ssr.name}`,
        resolve: {
          orderId: ($stateParams) => $stateParams.orderId,
        },
        templateProvider: ($stateParams) =>
          `<order-details-${ssr.name} order-id="${$stateParams.orderId}" mode="${mode}"/>`,
        // ...ssr,
      };
    });
  });

  Object.assign(
    states,
    getCatalogStates(`${base}.detail`, "catalogs", {
      nav: 8,
      menu: `${base}.detail`,
      authorize: undefined,
      breadcrumbs: false,
      pageHeader: false,
      resolve: {
        orderId: ($stateParams) => $stateParams.orderId,
        mode: ($stateParams) => $stateParams.mode,
      },
    })
  );

  return states;
};
